import { combineReducers } from "redux";
import { authReducer } from "./auth.reducer";
import { orgReducer } from "./organization.reducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  orgData: orgReducer,
});
